import React, { useState, useEffect } from 'react';
import { FaPen } from 'react-icons/fa';
import '../styles/ProfileField.css';

function ProfileField({ label, value, onChange, type = 'text', options = [], placeholder = '' }) {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
    setLocalValue(value || '');
  };

  const handleChange = (val) => {
    setLocalValue(val);
    if (onChange) onChange(val);
  };

  // Radio butonları render
  const renderRadioButtons = () => {
    if (options.length === 0) return null;

    return (
      <div className="radio-options">
        {options.map((opt, i) => (
          <label key={i}>
            <input
              type="radio"
              name={label.replace(/\s+/g, '')}
              value={opt}
              checked={localValue === opt}
              onChange={() => handleChange(opt)}
            />
            {opt}
          </label>
        ))}
      </div>
    );
  };

  return (
    <div className={`profile-field ${type === 'radio' ? 'radio-field' : ''}`}>
      <label>{label}</label>

      {!isEditing && (
        <div
          className="field-display"
          onClick={toggleEdit}
          style={{ cursor: 'pointer' }}
          title="Düzenlemek için tıklayın"
        >
          {localValue ? (
            <>
              {localValue}
              <span className="edit-icon" title="Düzenle">
                <FaPen style={{ marginLeft: 8, color: '#555', fontSize: '0.9rem' }} />
              </span>
            </>
          ) : (
            <i style={{ color: '#999' }}>Belirtilmemiş</i>
          )}
        </div>
      )}

      {isEditing && (
        <>
          {type === 'radio' && renderRadioButtons()}

          {type === 'textarea' && (
            <textarea
              value={localValue}
              onChange={e => handleChange(e.target.value)}
              onBlur={toggleEdit}
              autoFocus
              rows={4}
              placeholder={placeholder}
            />
          )}

          {type === 'select' && (
            <select
              value={localValue}
              onChange={e => handleChange(e.target.value)}
              onBlur={toggleEdit}
              autoFocus
            >
              <option value="">Seçiniz</option>
              {options.map((opt, i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
            </select>
          )}

          {(type === 'text' || type === 'tel' || type === 'number') && (
            <input
              type={type}
              value={localValue}
              onChange={e => handleChange(e.target.value)}
              onBlur={toggleEdit}
              autoFocus
              placeholder={placeholder}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ProfileField;
